import styled from 'styled-components';
import {ActionGuideTooltip} from '@/components/Tooltip';
import {AiVoteStateType} from '@/map/@types';
import {FlexFullGrow} from '@/styled-components';
import {palette} from '@/styles';
import UpVoteFillIcon from './assets/thumb-up-fill.svg';
import UpVoteIcon from './assets/thumb-up.svg';
import {CircleIconButton} from './StyledComponents';

interface IProps {
  voteState?: AiVoteStateType;
  onVote?(voteState: AiVoteStateType): void;
}

export const PanelFooter = ({voteState, onVote}: IProps) => {
  const isVoted = !!voteState;

  return (
    <Root>
      <FlexFullGrow>이 내용이 도움이 되었나요?</FlexFullGrow>
      {voteState !== 'down' && (
        <ActionGuideTooltip content="좋아요" place="top" offset={2}>
          <CircleIconButton disabled={isVoted} onClick={() => onVote?.('up')}>
            <img src={isVoted ? UpVoteFillIcon : UpVoteIcon} alt="좋아요" />
          </CircleIconButton>
        </ActionGuideTooltip>
      )}
      {voteState !== 'up' && (
        <ActionGuideTooltip content="아쉬워요" place="top" offset={2}>
          <CircleIconButton disabled={isVoted} onClick={() => onVote?.('down')}>
            <img
              src={isVoted ? UpVoteFillIcon : UpVoteIcon}
              style={{transform: 'rotate(180deg)'}}
              alt="아쉬워요"
            />
          </CircleIconButton>
        </ActionGuideTooltip>
      )}
    </Root>
  );
};

const Root = styled.div`
  padding: 12px 16px 16px;
  border-top: solid 1px ${palette.gray200};
  flex-shrink: 0;
  color: ${palette.gray800};
  font-size: 12px;
  font-weight: 500;
  letter-spacing: -0.36px;
  display: flex;
  align-items: center;
  gap: 16px;
`;
